export const DEFAULT_ACTION = '@@toyota/DEFAULT_ACTION';

export const cancelElementsEditing = (elements = []) => {
  elements.forEach((value) => {
    Object.assign(value, {'editable': false});
  });
  return elements;
};
